import { Form, Input, ModalProps, FormProps, Modal, InputNumber, useSelect, Select } from '@pankod/refine-antd'
import { useGetIdentity } from '@pankod/refine-core'
import { useUserContext } from 'context/user'
import { createUserHistory } from 'gql/mutations'
import { IGradeLevel, IMedium } from 'interfaces'

type CreateGradeProps = {
  modalProps: ModalProps
  formProps: FormProps
}

export const CreateGrade: React.FC<CreateGradeProps> = ({ modalProps, formProps }) => {
  const { data: user } = useGetIdentity()
  const { userRole } = useUserContext()
  const { selectProps: gradeLevelsSelectProps } = useSelect<IGradeLevel>({
    resource: 'grade_levels',
    fetchSize: 100,
    optionLabel: 'name',
    optionValue: 'id',
    metaData: {
      fields: ['id', 'name'],
    },
    sort: [{ field: 'name', order: 'asc' }],
    onSearch: value => [
      {
        field: 'name',
        operator: 'contains',
        value: `${value.toLowerCase()}%`,
      },
    ],
  })
  const onFinish = async (values: any) => {

    return (
      formProps?.onFinish &&
      formProps?.onFinish({
        ...values,
        created_by: user?.id
      })
    )

  }
  return (
    <Modal {...modalProps} title="Create Grade">
      <Form {...formProps} size="large" layout="vertical" onFinish={async values => {
        let response = await onFinish(values).then((response: any) => {
          if (response) {
            createUserHistory('grades', 'create', response?.data?.id, user?.id, userRole)
          }

        })

        return response
      }}>
        {/* <Form.Item
          label="Medium"
          name="medium_id"
          rules={[
            {
              required: true,
            },
          ]}
        >
          <Select {...mediumSelectProps} />
        </Form.Item> */}
        <Form.Item
          label="Grade Name"
          name="name"
          rules={[
            {
              required: true,
            },
          ]}
        >
          <Input type="number" />
        </Form.Item>
        <Form.Item
          label="Grade Levels "
          name="grade_levels_id"
          rules={[
            {
              required: true,
            },
          ]}
        >
          <Select {...gradeLevelsSelectProps} />
        </Form.Item>
        <Form.Item name="created_by" initialValue={user?.id}>
          <Input type="hidden" />
        </Form.Item>
      </Form>
    </Modal>
  )
}
